import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";

import Button from "@material-ui/core/Button";
import { notBlank } from "../../../util/ext";

const useStyles = makeStyles(theme => ({
  button: {
    width: "100%",
    height: 44,
    padding: theme.spacing(3, 4),
    marginBottom: theme.spacing(8),
  },

  uploadIcon: {
    "& > :first-child": {
      fontSize: "1.6rem",
    },
  },
}));

const UploadMediaButton = () => {
  const classes = useStyles();
  const history = useHistory();
  const { pathname, search } = useLocation();
  const handleClick = () => {
    const from = notBlank(search) ? pathname + search : pathname;
    history.push("/creator/upload", {
      from: from,
    });
  };

  return (
    <Button
      color="primary"
      variant="outlined"
      onClick={handleClick}
      classes={{
        root: classes.button,
        iconSizeMedium: classes.uploadIcon,
      }}
      startIcon={<FontAwesomeIcon icon={faPlus} />}
    >
      Upload Media
    </Button>
  );
};

export default UploadMediaButton;
